import Model, { attr, belongsTo } from '@ember-data/model';

export default Model.extend({
  fundId: attr('string'),
  userId: attr('string'),
  contact: belongsTo('assign-tasks/contact', { async: false, inverse: null }),
  summary: attr('string'),
  notes: attr('string'),
  dueAt: attr('date-only'),
  completedAt: attr('date-only'),
});
